import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { CodeService } from '../../shared/init/code.service';
@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'categoryName',
})
export class CategoryNamePipe implements PipeTransform {
  constructor(private codeService: CodeService) {}

  transform(code: string): any {
    const category = this.codeService.getDisplayCategoryAsValue(code);
    if (!category || !category.name) {
      return;
    }
    return category.name;
  }
}
